import application from 'stash/reducers/application';
import entities from 'stash/reducers/entities';

const rootReducer = {
	application,
	entities,
};

export default rootReducer;
